import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { BlogPost, ArticleSkeleton, ArticleError } from '@/admin/components';
import {
  AppContext,
  BlogFormProvider,
  defaultBlogValues,
  StorageBlobCleanProvider,
} from '@/admin/providers';
import { getBlogByIdApi } from '@/admin/utils/helpers-api';

export const EditBlogPage = () => {
  const { blogId } = useParams();

  const { selectedUserId, getAccessToken } = useContext(AppContext);

  const [defaultValues, setDefaultValues] = useState(defaultBlogValues);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const getBlogDataById = async (blogId: string) => {
    try {
      const token = await getAccessToken();
      const { status, data } = await getBlogByIdApi(
        token,
        blogId,
        selectedUserId
      );

      if (status === 200) {
        setDefaultValues(data[0]);
      } else {
        setIsError(true);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setIsError(true);
    }
  };

  useEffect(() => {
    if (blogId) {
      getBlogDataById(blogId);
    }
  }, []);

  if (isLoading) return <ArticleSkeleton />;

  if (isError) return <ArticleError />;

  return (
    <BlogFormProvider defaultValues={defaultValues}>
      <StorageBlobCleanProvider>
        <BlogPost isNewBlog={false} getBlogDataById={getBlogDataById} />
      </StorageBlobCleanProvider>
    </BlogFormProvider>
  );
};
